import { parseNbNOFloatOrNull } from "../common/CustomFunctions";
import { IApproverDocumentGuiModel, IApproverDocumentPostGuiModel, IApproverFlowGuiModel, IApproverFlowPostGuiModel, IApproverFlowPutGuiModel, IApproverUserGuiModel } from "../model/IApproverGuiModel";
import ApproverService from "../service/ApproverService";
import { IApproverDocumentModel, IApproverDocumentPostModel, IApproverFlowModel, IApproverFlowPostModel, IApproverFlowPutModel, IApproverUserModel } from "../service/model/IApproverModel";
import { BusinessLogicDefaultResult, BusinessLogicResult } from "./BusinessLogicResult";

export default class ApproverBusinessLogic {

    public async getApproverDocuments(
        organizationId: string,
        docType: "Mine" | "All",
        status: "ApprovalPending" | "ApprovalPostponed" | null,
    ): Promise<BusinessLogicResult<IApproverDocumentGuiModel[]>> {


        const service = new ApproverService();
        let result;

        if (docType === "Mine") {
            result = await service.getDocumentsMine(organizationId, true);
        } else {
            result = await service.getDocumentsAll(organizationId, true);
        }

        if (result.hasErrors) {

            return new BusinessLogicResult([], result.errors);

        } else {
            let apiData: IApproverDocumentModel[];
            if (status) {
                apiData = result.value.filter(e => e.status === status);
            } else {
                apiData = result.value;
            }

            let data = apiData.map(e => {
                return {
                    id: e.id,
                    amount: e.amount ? e.amount.toString().replace(".",",") : undefined,
                    invoiceNo: e.invoiceNo ? e.invoiceNo : undefined,
                    voucherDate: e.voucherDate ? new Date(e.voucherDate) : undefined,
                    dueDate: e.dueDate ? new Date(e.dueDate) : undefined,
                    cid: e.cid ? e.cid : undefined,
                    supplierId: e.supplierId ? e.supplierId : undefined,
                    supplierName: e.supplierName ? e.supplierName : undefined,
                    assignedUserId: e.assignedUserId ? e.assignedUserId : undefined,
                    assignedUserFullName: e.assignedUserFullName ? e.assignedUserFullName : undefined,
                    comment: e.comment ? e.comment : undefined,
                    status: e.status,
                    type: e.type,
                    lines: e.lines ? e.lines.map(f => {
                        return {
                            id: f.id,
                            account: !f.account ? undefined : {
                                accountId: f.account.accountId ? f.account.accountId.toString() : undefined,
                                name: f.account.name ? f.account.name : undefined,
                                accountType: f.account.accountType,
                                bankAccount: f.account.bankAccount ? f.account.bankAccount : undefined,
                                businessNumber: f.account.businessNumber ? f.account.businessNumber : undefined,
                                vatCode: f.account.vatCode ? f.account.vatCode.toString() : undefined
                            },
                            vatId: f.vatId ? f.vatId.toString() : undefined,
                            amount: f.amount ? f.amount.toString().replace(".", ",") : undefined,
                            projectId: f.projectId ? f.projectId : undefined,
                            departmentId: f.departmentId ? f.departmentId : undefined
                        }
                    }) : undefined,
                    requests: e.requests ? e.requests.map(f => {
                        return {
                            userId: f.userId,
                            status: f.status,
                            created: new Date(f.created),
                            finished: f.finished ? new Date(f.finished) : null,
                            step: f.step,
                            isActive: f.isActive,
                            userFirstName: f.userFirstName,
                            userLastName: f.userLastName,
                            userFullName: f.userFullName
                        }
                    }) : undefined,
                    files: e.files ? e.files : undefined,                    
                }
            });
            return new BusinessLogicResult(data, result.errors);
        }
    };
    public async getApproverDocument(
        organizationId: string, documentId: number,
    ): Promise<BusinessLogicResult<IApproverDocumentGuiModel | undefined>> {

        const service = new ApproverService();
        const result = await service.getDocument(organizationId, documentId);

        if (result.hasErrors) {

            return new BusinessLogicResult(undefined, result.errors);

        } else {
            let apiData: IApproverDocumentModel = result.value

            let data = {
                id: apiData.id,
                amount: apiData.amount ? apiData.amount.toString() : undefined,
                invoiceNo: apiData.invoiceNo ? apiData.invoiceNo : undefined,
                voucherDate: apiData.voucherDate ? new Date(apiData.voucherDate) : undefined,
                dueDate: apiData.dueDate ? new Date(apiData.dueDate) : undefined,
                cid: apiData.cid ? apiData.cid : undefined,
                supplierId: apiData.supplierId ? apiData.supplierId : undefined,
                supplierName: apiData.supplierName ? apiData.supplierName : undefined,
                assignedUserId: apiData.assignedUserId ? apiData.assignedUserId : undefined,
                assignedUserFullName: apiData.assignedUserFullName ? apiData.assignedUserFullName : undefined,
                comment: apiData.comment ? apiData.comment : undefined,
                status: apiData.status,
                type: apiData.type,
                lines: apiData.lines ? apiData.lines.map(f => {
                    return {
                        id: f.id,
                        account: !f.account ? undefined : {
                            accountId: f.account.accountId ? f.account.accountId.toString() : undefined,
                            name: f.account.name ? f.account.name : undefined,
                            accountType: f.account.accountType,
                            bankAccount: f.account.bankAccount ? f.account.bankAccount : undefined,
                            businessNumber: f.account.businessNumber ? f.account.businessNumber : undefined,
                            vatCode: f.account.vatCode ? f.account.vatCode.toString() : undefined
                        },
                        vatId: f.vatId ? f.vatId.toString() : undefined,
                        amount: f.amount ? f.amount.toString() : undefined,
                        projectId: f.projectId ? f.projectId : undefined,
                        departmentId: f.departmentId ? f.departmentId : undefined
                    }
                }) : undefined,
                requests: apiData.requests ? apiData.requests.map(f => {
                    return {
                        userId: f.userId,
                        status: f.status,
                        created: new Date(f.created),
                        finished: f.finished ? new Date(f.finished) : null,
                        step: f.step,
                        isActive: f.isActive,
                        userFirstName: f.userFirstName,
                        userLastName: f.userLastName,
                        userFullName: f.userFullName
                    }
                }) : undefined,
                files: apiData.files ? apiData.files : undefined,
            }
            return new BusinessLogicResult(data, result.errors);
        }
    };
    public async postDocument(
        organizationId: string, documentId: number, data: IApproverDocumentPostGuiModel
    ): Promise<BusinessLogicDefaultResult> {

        const service = new ApproverService();

        let apiData: IApproverDocumentPostModel = {

            amount: data.amount ? {
                value: data.amount.value ? parseNbNOFloatOrNull(data.amount.value) : null
            } : { value: null },
            invoiceNo: data.invoiceNo ? {
                value: data.invoiceNo.value ? data.invoiceNo.value : null
            } : { value: null },
            voucherDate: data.voucherDate ? {
                value: data.voucherDate.value ? data.voucherDate.value : null
            } : { value: null },
            dueDate: data.dueDate ? {
                value: data.dueDate.value ? data.dueDate.value : null
            } : { value: null },
            cid: data.cid ? {
                value: data.cid.value ? data.cid.value : null
            } : { value: null },
            supplierId: data.supplierId ? {
                value: data.supplierId.value ? data.supplierId.value : null
            } : { value: null },
            comment: data.comment ? {
                value: data.comment.value ? data.comment.value : null
            } : { value: null },
            lines: data.lines ? data.lines.map(e => {
                return {
                    lineId: e.lineId ? e.lineId : null,
                    debitAccountId: e.debitAccountId ? parseInt(e.debitAccountId) : null,
                    debitVatId: e.debitVatId ? parseInt(e.debitVatId) : null,
                    amount: e.amount ? parseInt(e.amount) : null,
                    projectId: e.projectId ? parseInt(e.projectId) : null,
                    departmentId: e.departmentId ? parseInt(e.departmentId) : null
                }
            }) : null,
        }

        const result = await service.postDocumentData(organizationId, documentId, apiData);

        if (result.hasErrors) {
            return new BusinessLogicDefaultResult(result.errors);
        } else {
            return new BusinessLogicDefaultResult([]);
        }
    }
    public async postDocmentApprove(
        organizationId: string,
        documentId: number,
        newUserId?: string): Promise<BusinessLogicDefaultResult> {

        const service = new ApproverService();

        const result = await service.postDocumentApprove(organizationId, documentId, newUserId);

        if (result.hasErrors) {
            return new BusinessLogicDefaultResult(result.errors);
        } else {
            return new BusinessLogicDefaultResult([]);
        }
    }
    public async postDocmentReject(
        organizationId: string,
        documentId: number): Promise<BusinessLogicDefaultResult> {

        const service = new ApproverService();

        const result = await service.postDocumentReject(organizationId, documentId);

        if (result.hasErrors) {
            return new BusinessLogicDefaultResult(result.errors);
        } else {
            return new BusinessLogicDefaultResult([]);
        }
    }
    public async postDocmentPostpone(
        organizationId: string,
        documentId: number): Promise<BusinessLogicDefaultResult> {

        const service = new ApproverService();

        const result = await service.postDocumentPostpone(organizationId, documentId);

        if (result.hasErrors) {
            return new BusinessLogicDefaultResult(result.errors);
        } else {
            return new BusinessLogicDefaultResult([]);
        }
    }
    public async postDocmentAssign(
        organizationId: string,
        documentId: number,
        newUserId?: string): Promise<BusinessLogicDefaultResult> {

        const service = new ApproverService();

        const result = await service.postDocumentAssign(organizationId, documentId, newUserId);

        if (result.hasErrors) {
            return new BusinessLogicDefaultResult(result.errors);
        } else {
            return new BusinessLogicDefaultResult([]);
        }
    }
    public async postDocmentSwitchFlow(
        organizationId: string,
        documentId: number,
        newFlowId?: number): Promise<BusinessLogicDefaultResult> {

        const service = new ApproverService();

        const result = await service.postDocumentSwitchFlow(organizationId, documentId, newFlowId ? newFlowId : undefined);

        if (result.hasErrors) {
            return new BusinessLogicDefaultResult(result.errors);
        } else {
            return new BusinessLogicDefaultResult([]);
        }
    }
    public async postDocmentStartApproval(
        organizationId: string,
        documentId: number): Promise<BusinessLogicDefaultResult> {

        const service = new ApproverService();

        const result = await service.postDocumentStartApproval(organizationId, documentId);

        if (result.hasErrors) {
            return new BusinessLogicDefaultResult(result.errors);
        } else {
            return new BusinessLogicDefaultResult([]);
        }
    }
    public async getApprovers(
        organizationId: string,
    ): Promise<BusinessLogicResult<IApproverUserGuiModel[]>> {


        const service = new ApproverService();
        let result;

        result = await service.getApprovers(organizationId);

        if (result.hasErrors) {

            return new BusinessLogicResult([], result.errors);

        } else {
            let apiData: IApproverUserModel[] = result.value;

            let data = apiData.map(e => {
                return {
                    user: {
                        id: e.user.id,
                        email: e.user.email ? e.user.email : undefined,
                        firstName: e.user.firstName ? e.user.firstName : undefined,
                        lastName: e.user.lastName ? e.user.lastName : undefined,
                        language: e.user.language ? e.user.language : undefined,
                        fullName: e.user.fullName ? e.user.fullName : undefined,
                        mustChangePassword: e.user.mustChangePassword,
                        modules: e.user.modules ? e.user.modules.map(f => {
                            return f
                        }) : undefined,
                    },
                    numberOfRequests: e.numberOfRequests,
                }
            });
            return new BusinessLogicResult(data, result.errors);
        }
    };
    public async postApproverReplace(
        organizationId: string,
        id: string,
        newUserId: string): Promise<BusinessLogicDefaultResult> {

        const service = new ApproverService();

        const result = await service.postApproverReplace(organizationId, id, newUserId);

        if (result.hasErrors) {
            return new BusinessLogicDefaultResult(result.errors);
        } else {
            return new BusinessLogicDefaultResult([]);
        }
    }

    public async getApproverFlows(
        organizationId: string,
    ): Promise<BusinessLogicResult<IApproverFlowGuiModel[]>> {


        const service = new ApproverService();
        let result;

        result = await service.getApproverFlows(organizationId);

        if (result.hasErrors) {

            return new BusinessLogicResult([], result.errors);

        } else {
            let apiData: IApproverFlowModel[] = result.value;

            let data = apiData.map(e => {
                return {
                    id: e.id,
                    organizationId: e.organizationId,
                    name: e.name,
                    order: e.order,
                    autoAssignable: e.autoAssignable,
                    amountLimit: e.amountLimit ? e.amountLimit.toString() : undefined,
                    suppliers: e.suppliers ? e.suppliers.map(e => {
                        return {
                            customerId: e.customerId ? e.customerId : undefined,
                            supplierId: e.supplierId ? e.supplierId : undefined,
                            name: e.name ? e.name : undefined,
                            bankAccount: e.bankAccount ? e.bankAccount : undefined,
                            businessNumber: e.businessNumber ? e.businessNumber : undefined,
                            addressLine1: e.addressLine1 ? e.addressLine1 : undefined,
                            addressLine2: e.addressLine2 ? e.addressLine2 : undefined,
                            isoCountryCode: e.isoCountryCode ? e.isoCountryCode : undefined,
                            postalCode: e.postalCode ? e.postalCode : undefined,
                            postArea: e.postArea ? e.postArea : undefined,
                            emailAddress: e.emailAddress ? e.emailAddress : undefined,
                            comment: e.comment ? e.comment : undefined,
                        }
                    }) : undefined,
                    users: e.users.map(e => {
                        return {
                            id: e.id,
                            email: e.email ? e.email : undefined,
                            firstName: e.firstName ? e.firstName : undefined,
                            lastName: e.lastName ? e.lastName : undefined,
                            language: e.language ? e.language : undefined,
                            fullName: e.fullName ? e.fullName : undefined,
                            mustChangePassword: e.mustChangePassword,
                            modules: e.modules ? e.modules : undefined,
                        }
                    }),
                }
            });
            return new BusinessLogicResult(data, result.errors);
        }
    };
    public async getApproverFlow(
        organizationId: string, id: number
    ): Promise<BusinessLogicResult<IApproverFlowGuiModel | undefined>> {


        const service = new ApproverService();
        let result = await service.getApproverFlow(organizationId, id);

        if (result.hasErrors) {

            return new BusinessLogicResult(undefined, result.errors);

        } else {

            let apiData: IApproverFlowModel = result.value;

            let data = {
                id: apiData.id,
                organizationId: apiData.organizationId,
                name: apiData.name,
                order: apiData.order,
                autoAssignable: apiData.autoAssignable,
                amountLimit: apiData.amountLimit ? apiData.amountLimit.toString() : undefined,
                suppliers: apiData.suppliers ? apiData.suppliers.map(e => {
                    return {
                        customerId: e.customerId ? e.customerId : undefined,
                        supplierId: e.supplierId ? e.supplierId : undefined,
                        name: e.name ? e.name : undefined,
                        bankAccount: e.bankAccount ? e.bankAccount : undefined,
                        businessNumber: e.businessNumber ? e.businessNumber : undefined,
                        addressLine1: e.addressLine1 ? e.addressLine1 : undefined,
                        addressLine2: e.addressLine2 ? e.addressLine2 : undefined,
                        isoCountryCode: e.isoCountryCode ? e.isoCountryCode : undefined,
                        postalCode: e.postalCode ? e.postalCode : undefined,
                        postArea: e.postArea ? e.postArea : undefined,
                        emailAddress: e.emailAddress ? e.emailAddress : undefined,
                        comment: e.comment ? e.comment : undefined,
                    }
                }) : undefined,
                users: apiData.users.map(e => {
                    return {
                        id: e.id,
                        email: e.email ? e.email : undefined,
                        firstName: e.firstName ? e.firstName : undefined,
                        lastName: e.lastName ? e.lastName : undefined,
                        language: e.language ? e.language : undefined,
                        fullName: e.fullName ? e.fullName : undefined,
                        mustChangePassword: e.mustChangePassword,
                        modules: e.modules ? e.modules : undefined,
                    }
                }),
            };
            return new BusinessLogicResult(data, result.errors);
        }
    };
    public async postApproverFlow(
        organizationId: string,
        id: number,
        data: IApproverFlowPostGuiModel): Promise<BusinessLogicDefaultResult> {

        const service = new ApproverService();

        let apiData: IApproverFlowPostModel = {
            name: data.name,
            autoAssignable: data.autoAssignable,
            amountLimit: data.amountLimit ? parseNbNOFloatOrNull(data.amountLimit) : null,
            users: data.users,
            suppliers: data.suppliers ? {
                value: data.suppliers.value ? data.suppliers.value : null
            } : null
        } 


        const result = await service.postApproverFlow(organizationId, id, apiData);

        if (result.hasErrors) {
            return new BusinessLogicDefaultResult(result.errors);
        } else {
            return new BusinessLogicDefaultResult([]);
        }
    };
    public async postApproverFlowsReorder(organizationId: string, flows: number[]): Promise<BusinessLogicDefaultResult> {

        const service = new ApproverService();

        const result = await service.postApproverFlowsReorder(organizationId, flows);

        if (result.hasErrors) {
            return new BusinessLogicDefaultResult(result.errors);
        } else {
            return new BusinessLogicDefaultResult([]);
        }
    }
    public async deleteApproverFlow(
        organizationId: string,
        id: number): Promise<BusinessLogicDefaultResult> {

        const service = new ApproverService();

        const result = await service.deleteApproverFlow(organizationId, id);

        if (result.hasErrors) {
            return new BusinessLogicDefaultResult(result.errors);
        } else {
            return new BusinessLogicDefaultResult([]);
        }
    };
    public async putApproverFlow(
        organizationId: string,
        id: number,
        data: IApproverFlowPutGuiModel): Promise<BusinessLogicDefaultResult> {

        const service = new ApproverService();

        let apiData: IApproverFlowPutModel = {
            name: data.name ? { value: data.name.value } : null,
            autoAssignable: data.autoAssignable ? {
                value: data.autoAssignable.value
            } : null,
            amountLimit: data.amountLimit ? {
                value: data.amountLimit.value ? parseNbNOFloatOrNull(data.amountLimit.value) : null
            } : null,
            users: data.users ? { value: data.users.value } : null,
            order: data.order ? { value: data.order.value } : null,
            suppliers: data.suppliers ? {
                value: data.suppliers.value ? data.suppliers.value : null
            } : null,
        }

        const result = await service.putApproverFlow(organizationId, id, apiData);

        if (result.hasErrors) {
            return new BusinessLogicDefaultResult(result.errors);
        } else {
            return new BusinessLogicDefaultResult([]);
        }
    }
}